/**
 * Reine Hilfsfunktionen rund um den Kampagnen-Zeitplan (Wochentags-Konstante
 * für die Auswahl-Tabelle in Schritt 4 sowie Datums-/Zeit-Formatierung für
 * die Anzeige). Die frühere grobe Klartext-Schätzung (buildSchedulePreview)
 * wurde ersetzt: Schritt 4 zeigt jetzt die ECHTE Versandplan-Vorschau aus
 * CampaignSchedulePlanner::preview() (vom Controller als Prop übergeben),
 * weil der tatsächliche Versand außerdem earliest_send_at je Empfänger und
 * das total_to_send-Limit berücksichtigt - eine reine Klartext-Schätzung
 * konnte das nicht abbilden.
 */

export const WEEKDAYS = [
    {value: 1, label: "Mo"},
    {value: 2, label: "Di"},
    {value: 3, label: "Mi"},
    {value: 4, label: "Do"},
    {value: 5, label: "Fr"},
    {value: 6, label: "Sa"},
    {value: 0, label: "So"},
];

const WEEKDAY_SHORT = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];

function parseDate(value) {
    if (!value) {
        return null;
    }
    const d = new Date(`${value}T00:00:00`);
    return Number.isNaN(d.getTime()) ? null : d;
}

export function formatGermanDate(value) {
    const d = parseDate(value);
    if (!d) {
        return null;
    }
    const weekday = WEEKDAY_SHORT[d.getDay()];
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    return `${weekday} ${day}.${month}.`;
}

/**
 * Formatiert einen vollen Zeitstempel (ISO-String, z. B. aus
 * CampaignSchedulePlanner::preview()/plan()) als "Mo 28.07. 08:04".
 */
export function formatGermanDateTime(value) {
    if (!value) {
        return null;
    }
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) {
        return null;
    }
    const weekday = WEEKDAY_SHORT[d.getDay()];
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    return `${weekday} ${day}.${month}. ${hours}:${minutes}`;
}
